import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "../reducer";

export const store = configureStore({
  reducer: commonReducer,
});
